import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'semantic-ui-css/semantic.min.css'
import Provider from 'modules/wd-api-request-handler'
import Handle from "modules/wd-transit/handle";

const root = ReactDOM.createRoot(document.getElementById('root'));
const base_url = "https://api2.webdoko.com/"

root.render(
  <React.StrictMode>
    <Provider baseUrl="https://api2.webdoko.com/" siteTitle="blog.webdoko.com">
      <App />
      <Handle {...{base_url}} />
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
